// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles-module--sidebar--f84712"};